export default "__VITE_ASSET__6e42920a__"